export default __webpack_public_path__ + "static/media/sample_1.b282fc49.png";